<template>
  <div>
    <div class="volume">
      <input
        type="range"
        min="0"
        max="100"
        :value="volume"
        class="volume-range">
        <!-- @change="changeVolume" -->
      <div
        class="icon"
      >
        <!-- @click="toggleMute" -->
          <!-- <i
            v-show="!isMute"
            class="fa fa-volume-up icon-size" aria-hidden="true"></i>
          <i
            v-show="isMute"
            class="fas fa-volume-off icon-size"
          ></i> -->
        <img
          src="@/assets/images/audio/btn_player_volume.png"
          alt="btn_player_volume"
        >
      </div>
      <div
        @touchstart="touchstartVolume"
        @touchend="touchendVolume"
        @mousedown="mousedownVolume"
        @mouseup="mouseupVolume"
        ref="volumeBar"
        class="bar-hoverbox"
        >
        <!-- @touchmove="touchmoveVolume" -->
        <!-- @mousemove="mousemoveVolume" -->
        <div class="bar">
          <div
            v-show="!isMute"
            class="bar-fill"
            :style="volumeObject">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'VolumeBar',
  data () {
    return {
      volume: 60,
      volumeObject: {
        width: '60%'
      },
      barStillDown: false,
      isMute: false,
      startPageX: null,
      touch: {}
    }
  },
  computed: {
    ...mapState({

    }),
    ...mapGetters({})
  },
  watch: {},
  methods: {
    // changeVolume(e) {
    //   console.log("value", e.value);
    // },
    setvolume (value) {
      // console.log(value);
      this.volume = value
      this.volumeObject.width = value + '%'
      // let playerVolume = (value/100).toFixed(2);
      this.$emit('changeVolume', value)
    },
    calculateFill (e) {
      // console.log(e)
      const offsetX = e.offsetX
      let parseOffsetX = 0
      console.log(e)
      if (e.type === 'touchmove') {
        // console.log(e.touches[0])
        // console.log(e.touches[0].pageX)
        // offsetX = e.touches[0].pageX - e.touches[0].target.offsetLeft
        parseOffsetX = e.touches[0].pageX - this.startPageX
        console.log(parseOffsetX)
      }
      const width = e.target.offsetWidth - 10
      console.log(offsetX)
      console.log(width)
      this.setvolume(
        Math.max(
          Math.min(
            (offsetX - 5) / width * 100.0,
            100.0
          ),
          0
        )
      )
    },
    touchstartVolume (e) {
      console.log('touchstart')
      // console.log(e)
      // if (this.isMute === true) {
      //   this.isMute = false
      // }
      // this.startPageX = e.touches[0].pageX
      // this.barStillDown = true
      // this.calculateFill(e)

      this.touch.initiated = true
      this.touch.startX = e.touches[0].pageX
      this.touch.offsetX = e.touches[0].pageX - e.touches[0].target.offsetLeft
      console.log(this.touch)
    },
    mousedownVolume (e) {
      if (this.isMute === true) {
        this.isMute = false
      }
      this.barStillDown = true
      this.calculateFill(e)
    },
    touchmoveVolume (e) {
      console.log('touchmove')
      if (!this.touch.initiated) {
        return
      }
      const deltaX = e.touches[0].pageX - this.touch.offsetX
      const width = this.$refs.volumeBar.clientWidth - 6
      const offsetWidth = Math.min(100, Math.max(0, (deltaX) / width * 100.0))
      // console.log(deltaX)
      // console.log(offsetWidth)
      this.setvolume(offsetWidth)
    },
    mousemoveVolume (e) {
      if (this.barStillDown) {
        this.calculateFill(e)
      }
    },
    // mousewheelVolume (e) {
    //   const newValue = +range.value + e.deltaY * 0.5
    //   setValue(Math.max(
    //     Math.min(
    //       newValue,
    //       100.0
    //     ),
    //     0
    //   ))
    // },
    mouseupVolume () {
      this.barStillDown = false
    },
    touchendVolume () {
      this.barStillDown = false
    },
    toggleMute () {
      this.isMute = !this.isMute
      this.$emit('toggleMute', this.isMute)
    }

  },
  mounted () {
    // const move = document.querySelector('.bar-hoverbox')
    // move.addEventListener('touchmove', _debounce(this.touchmoveVolume, 500))
  }
}
</script>

<style lang="scss" scoped >
@import "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.13.1/css/all.min.css";

.volume {
  display: flex;
  justify-content: flex-end;
  align-items:flex-start;
  input[type=range] {
    display: none;
  }
  .icon {
    align-self: center;
    // cursor: pointer;
  }

  .icon-size {
    font-size: 15px;
    color: white;
  }

  .bar-hoverbox {
    padding: 10px 0;
    // opacity: 0.7;
    // transition: opacity .2s;
    align-self: center;
    margin-left: 5px;
    &:hover {
      // opacity: 1;
      cursor: pointer;
    }
  }

  .bar {
    background: rgba(255, 255, 255, 0.3);
    height: 5px;
    width: 100px;
    border-radius: 15px;
    pointer-events: none;

    .bar-fill {
      background:#176E8D;
      width: 0%;
      height: 100%;
      background-clip: border-box;
      pointer-events: none;
      position: relative;
      &::after{
        content: "";
        width: 12px;
        height: 12px;
        background: white;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
      }
    }
  }
  @media (max-width: 991px) {
    .bar {
      width: 70px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/widget/AudioPlayer/components/VolumeBar.vue